import en from '../en/iconclass'

const cz: typeof en = {
  search_illustration: 'Vyhledejte ilustraci',
  go_to_iconclass: 'Přejít na ICONCLASS',
  themes: 'Témata',
  deselect_all: 'Odznačit vše',
  filter: 'Filtrovat',
  title: 'Název',
  icc_code: 'ICONCLASS kód',
  icc_name: 'ICONCLASS termín',
  identifier: 'ID záznamu',
}

export default cz
